export default __webpack_public_path__ + "static/media/Products.e61a66b7.svg";